export default __webpack_public_path__ + "static/media/iotchain1.b7edbf67.png";